import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['userAssignment', 'teamAssignment']

  connect () {
    this.toggleAssignmentType()
  }

  toggleAssignmentType () {
    const userRadio = this.element.querySelector('input[name="assignment_type"][value="user"]')
    const teamRadio = this.element.querySelector('input[name="assignment_type"][value="team"]')

    if (userRadio && userRadio.checked) {
      this.showUserAssignment()
    } else if (teamRadio && teamRadio.checked) {
      this.showTeamAssignment()
    }
  }

  showUserAssignment () {
    this.userAssignmentTarget.style.display = 'block'
    this.teamAssignmentTarget.style.display = 'none'
    this.teamAssignmentTarget.querySelector('select').value = ''
  }

  showTeamAssignment () {
    this.userAssignmentTarget.style.display = 'none'
    this.teamAssignmentTarget.style.display = 'block'
    this.userAssignmentTarget.querySelector('select').value = ''
  }
}
